import { render, staticRenderFns } from "./allianceCoupon.vue?vue&type=template&id=0c83c04c&scoped=true"
import script from "./allianceCoupon.vue?vue&type=script&lang=js"
export * from "./allianceCoupon.vue?vue&type=script&lang=js"
import style0 from "./allianceCoupon.vue?vue&type=style&index=0&id=0c83c04c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c83c04c",
  null
  
)

export default component.exports